/**
 * GuildWindow.ts - 길드 정보창 (기본 단축키 G)
 * - 현재 소속 길드 정보 (<솔라리스 초보자길드>)
 * - 길드 멤버 및 길드 채팅 바로가기
 */

import { EntityRegistry } from '../../core/EntityRegistry';
import { EntityState } from '../../core/Types';
import { HudLayout } from '../view/DaocHud';

export class GuildWindow {
  private el: HTMLElement | null = null;
  private isOpen = false;

  constructor(private registry: EntityRegistry) {}

  public mount(parent: HTMLElement): void {
    const el = document.createElement('div');
    el.id = 'guild-window';
    el.style.display = 'none';
    el.style.flexDirection = 'column';
    el.style.overflow = 'hidden';
    el.style.color = '#e8dcc0';
    el.style.userSelect = 'none';
    el.style.background = 'linear-gradient(180deg, rgba(15, 23, 42, 0.96), rgba(8, 14, 26, 0.98))';
    el.style.border = '1.5px solid #22c55e';
    el.style.borderRadius = '8px';
    el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.8), 0 0 15px rgba(34, 197, 94, 0.2)';
    parent.appendChild(el);
    this.el = el;
    HudLayout.wrap(el, { id: 'win-guild', mode: 'free', anchor: 'tl', dx: 320, dy: 150, w: 340, h: 360, minW: 260, minH: 220 });
    this.render();
  }

  public toggle(): void {
    this.isOpen = !this.isOpen;
    if (this.el) {
      this.el.style.display = this.isOpen ? 'flex' : 'none';
      if (this.isOpen) this.render();
    }
  }

  public open(): void {
    this.isOpen = true;
    if (this.el) {
      this.el.style.display = 'flex';
      this.render();
    }
  }

  public close(): void {
    this.isOpen = false;
    if (this.el) this.el.style.display = 'none';
  }

  public render(): void {
    if (!this.el) return;
    const player = this.registry.getPlayer();
    const guildName = (player?.appearance?.guild as string) || '솔라리스 초보자길드';

    this.el.innerHTML = `
      <div style="display:flex; justify-content:space-between; align-items:center; padding:10px 14px; background:linear-gradient(90deg, #14532d, #0f172a); border-bottom:1px solid #22c55e;">
        <span style="font-weight:bold; font-size:14px; color:#4ade80; display:flex; align-items:center; gap:6px;">
          🏰 길드 정보 [G]
        </span>
        <button id="guild-close-btn" style="background:none; border:none; color:#94a3b8; font-size:16px; cursor:pointer; padding:0 4px;">✕</button>
      </div>
      <div style="padding:14px; display:flex; flex-direction:column; gap:12px; overflow-y:auto; flex:1;">
        <div style="background:rgba(20, 83, 45, 0.25); border:1px solid rgba(34, 197, 94, 0.4); border-radius:6px; padding:10px;">
          <div style="font-size:11px; color:#86efac; font-weight:600;">소속 길드</div>
          <div style="font-size:17px; font-weight:800; color:#22c55e; margin-top:2px;">&lt;${guildName}&gt;</div>
          <div style="font-size:11px; color:#94a3b8; margin-top:4px;">솔라리스 왕국 신규 모험가들의 공식 육성 길드입니다.</div>
        </div>

        <div style="background:rgba(15, 23, 42, 0.6); border:1px solid #1e293b; border-radius:6px; padding:10px;">
          <div style="display:flex; justify-content:space-between; margin-bottom:6px; font-size:12px; color:#cbd5e1;">
            <span>길드 마스터</span>
            <span style="color:#fde047; font-weight:bold;">👑 솔라리스 기사단장</span>
          </div>
          <div style="display:flex; justify-content:space-between; margin-bottom:6px; font-size:12px; color:#cbd5e1;">
            <span>길드 직급</span>
            <span style="color:#67e8f9; font-weight:600;">초보 모험가</span>
          </div>
          <div style="display:flex; justify-content:space-between; font-size:12px; color:#cbd5e1;">
            <span>길드 혜택</span>
            <span style="color:#4ade80;">경험치 +10% 버프 적용 중</span>
          </div>
        </div>

        <div style="background:rgba(15, 23, 42, 0.6); border:1px solid #1e293b; border-radius:6px; padding:10px; flex:1;">
          <div style="font-size:12px; font-weight:bold; color:#f8fafc; margin-bottom:8px; display:flex; justify-content:space-between;">
            <span>길드원 목록</span>
            <span style="color:#22c55e; font-size:11px;">● 온라인</span>
          </div>
          <div style="display:flex; flex-direction:column; gap:6px; font-size:12px;">
            <div style="display:flex; justify-content:space-between; padding:4px 8px; background:rgba(34, 197, 94, 0.1); border-radius:4px;">
              <span style="color:#f8fafc;">${player?.name || '나'} (나)</span>
              <span style="color:#94a3b8;">Lv.${player?.level || 1} ${player?.job || '모험가'}</span>
            </div>
            <div style="display:flex; justify-content:space-between; padding:4px 8px; background:rgba(255, 255, 255, 0.03); border-radius:4px;">
              <span style="color:#cbd5e1;">엘리시아</span>
              <span style="color:#94a3b8;">Lv.20 솔라리스 가이드</span>
            </div>
          </div>
        </div>

        <div style="font-size:11px; color:#64748b; line-height:1.4;">
          💬 길드 채팅 사용법: <code style="color:#4ade80; background:rgba(0,0,0,0.3); padding:1px 4px; border-radius:3px;">/g &lt;할말&gt;</code> 또는 길드 탭에서 대화하세요.
        </div>
      </div>
    `;

    this.el.querySelector('#guild-close-btn')?.addEventListener('click', () => {
      this.close();
    });
  }
}
